import { useGeolocation } from '@uidotdev/usehooks';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaSearch } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { IShipmentService, PostalDropOption } from '../../../../@posturinn/client-react';
import { closeAllModals } from '../../../../actions/modalActions';
import useLocations from '../../../../hooks/useLocations';
import { ReactComponent as Close } from '../../../../icons/close-button.svg';
import { A } from '../../../base/typography';
import { LocationsMapContainer } from '../../../map/mapContainer';
import * as StyledModals from '../myShipmentsModals.styles';
import DropOffList from './dropOffList';

interface Props {}

const PostboxesStatusModal: FC<Props> = () => {
	const dispatch = useDispatch<any>();
	const { t } = useTranslation('myShipments');
	const { locations } = useLocations();
	const RVK_LAT = 64.1256369;
	const RVK_LNG = -21.8756546;
	const ICELAND_CENTER_LAT = 64.9386083;
	const ICELAND_CENTER_LNG = -18.8422143;
	const geolocation = useGeolocation();
	const [latitude, setLatitude]: [number, any] = useState(geolocation.latitude || RVK_LAT);
	const [longitude, setLongitude]: [number, any] = useState(geolocation.longitude || RVK_LNG);
	const [zoom, setZoom]: [number, any] = useState(12);
	const [selectedLocation, setSelectedLocation]: [string, any] = useState(null);
	const [searchQuery, setSearchQuery] = useState('');

	// TODO
	// Mobile view, eins og er hverfur mapið - spurning með að taka þá bara snúning með hvernig afhendingarvals mobile viewið er líka

	const { modalHeading, modalCallback } = useSelector(({ modalReducer }) => modalReducer);
	const { injector } = useSelector(({ mobizReducer }) => mobizReducer);
	const shipmentService: IShipmentService = injector.get(IShipmentService);
	const [dropOffLocations, setDropOffLocations] = useState(null);

	if (!dropOffLocations)
		shipmentService.getDropOptions(modalHeading, modalCallback).subscribe({
			next: (dropOptions: PostalDropOption[]) => {
				const doLocations = [];
				locations.forEach(location => {
					for (let i = 0; i < dropOptions.length; i++) {
						if (dropOptions[i].deliveryLocationId === location.id) {
							const doLocation = {
								...location,
								status: dropOptions[i].boxAvailability,
							};
							doLocations.push(doLocation);
							break;
						}
					}
				});
				setDropOffLocations(doLocations);
			},
		});

	const onMarkerClick = (locationId, lat, lng, scroll) => {
		if (scroll) document.getElementById(locationId).scrollIntoView();
		setSelectedLocation(locationId);
		setLatitude(lat);
		setLongitude(lng);
		setZoom(16);
	};

	const search = location => {
		return (
			(searchQuery.length === 0 ||
				location.name.toUpperCase().includes(searchQuery.toUpperCase()) ||
				location.address.postalCode.toUpperCase().includes(searchQuery.toUpperCase()) ||
				location.address.street1.toUpperCase().includes(searchQuery.toUpperCase()) ||
				location.locationType.toUpperCase().includes(searchQuery.toUpperCase())) &&
			// TODO temporary filter while postboxes get sorted out
			!(
				location.name.toUpperCase().includes('PÓSTBOX') &&
				(location.name.toUpperCase().includes('KLEPPSVEGI') ||
					location.name.toUpperCase().includes('SUÐURSTRÖND'))
			)
		);
	};

	const onChange = e => {
		setSearchQuery(e.target.value);
		setZoom(7);
		setLatitude(ICELAND_CENTER_LAT);
		setLongitude(ICELAND_CENTER_LNG);
	};

	const closeModal = () => {
		dispatch(closeAllModals());
		document.body.style.overflow = 'unset';
	};
	document.body.style.overflow = 'hidden';

	return (
		<StyledModals.Wrapper large>
			<StyledModals.FullHeightColumns>
				<StyledModals.DeliveryOptionsWrapper desktopSmall={5 / 12}>
					<div>
						<StyledModals.Heading>
							<div>{t('page-overview.dropoffStatuses')}</div>
							<A onClick={closeModal}>
								<Close />
							</A>
						</StyledModals.Heading>
					</div>
					<StyledModals.InputWrapper>
						<StyledModals.SearchInputWrapper>
							<StyledModals.SearchInput
								type="text"
								value={searchQuery}
								onChange={onChange}
								placeholder={`${t('page-settings.deliveryOptionSearch')}`}
							/>
							<FaSearch />
						</StyledModals.SearchInputWrapper>
					</StyledModals.InputWrapper>
					<DropOffList
						search={search}
						locations={dropOffLocations}
						selectedLocation={selectedLocation}
						setSelectedLocation={onMarkerClick}
					/>
				</StyledModals.DeliveryOptionsWrapper>
				<StyledModals.StyledColumn desktopSmall={7 / 12}>
					<StyledModals.MapWrapper>
						<LocationsMapContainer
							lat={latitude}
							lng={longitude}
							locations={dropOffLocations}
							zoom={zoom}
							onMarkerClick={onMarkerClick}
							search={search}
						/>
					</StyledModals.MapWrapper>
				</StyledModals.StyledColumn>
			</StyledModals.FullHeightColumns>
		</StyledModals.Wrapper>
	);
};

export default PostboxesStatusModal;
